// extracted by mini-css-extract-plugin
export default {"header-container":"header_header-container__MUSea","logo":"header_logo__Zc04F"};